// 🎯 React and Material UI imports
import React, { useState, useEffect } from "react";
import "../CSS/Home.css";
import {
  Snackbar,
  Alert,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

const MODELS = [
  { id: "claude-sonnet-4-20250514", label: "Sonnet 4" },
  { id: "claude-3-7-sonnet-20250219", label: "Sonnet 3.7" },
  { id: "claude-3-5-haiku-20241022", label: "Haiku 3.5" },
];
// 🏠 Home component — landing page of the app
const Home = () => {
  // 🔐 Local state for storing the API key and snackbar messages
  const [apiKey, setApiKey] = useState("");
  const defaultModel = "claude-sonnet-4-20250514";
  const [model, setModel] = useState(defaultModel);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // success | error | info | warning

  // ⏪ Load saved API key from sessionStorage when component mounts
  useEffect(() => {
    const storedKey = sessionStorage.getItem("anthropicApiKey");
    const storedModel = sessionStorage.getItem("anthropicModel");
    if (storedKey) setApiKey(storedKey);
    if (storedModel) setModel(storedModel);
  }, []);

  // 💾 Save the entered API key to sessionStorage and show feedback
  const handleSaveKey = () => {
    sessionStorage.setItem("anthropicApiKey", apiKey);
    setSnackbarMessage("המפתח נשמר בהצלחה!");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  };

  const handleSaveModel = () => {
    sessionStorage.setItem("anthropicModel", model);
    setSnackbarMessage("המודל נשמר בהצלחה!");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  };

  return (
    <main className="main-content">
      {/* 🧭 Welcome section */}
      <section className="hero">
        <h1>ברוכים הבאים לResqgen!</h1>
      </section>

      {/* 🔑 API Key input section */}
      <section className="api-key-section">
        <h2>הכנס את מפתח הAPI שלך</h2>
        <p>מפתח זה דרוש למען התחברות לAPI של קלוד</p>
        <div className="api-key-form">
          <input
            type="password"
            placeholder="מפתח API"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)} // Update input value
          />
          <button onClick={handleSaveKey}>שמור</button>
        </div>
      </section>

      {/* 🧩 Model selection */}
      <section className="api-key-section" style={{ marginTop: 32 }}>
        <h2>בחר מודל קלוד</h2>
        <div className="api-key-form">
          <FormControl fullWidth>
            <InputLabel>מודל</InputLabel>
            <Select
              value={model}
              label="מודל"
              onChange={(e) => setModel(e.target.value)}
            >
              {MODELS.map((m) => (
                <MenuItem key={m.id} value={m.id}>
                  {m.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <button onClick={handleSaveModel} disabled={!model}>
            שמור
          </button>
        </div>
      </section>

      {/* ℹ️ Explanation of the app flow */}
      <section className="how-it-works">
        <h1>איך זה עובד?</h1>
        <div className="steps">
          {/* Step 1: Select a category */}
          <div className="step">
            <div className="step-title">
              <div className="step-icon">{/* Optional icon */}</div>
              <h2>בחירה</h2>
            </div>
            <p>צור או בחר יחידת לימוד שבה תרצה ליצור שאלה</p>
          </div>

          {/* Step 2: Provide learning material */}
          <div className="step">
            <div className="step-title">
              <div className="step-icon">{/* Optional icon */}</div>
              <h2>למידה</h2>
            </div>
            <p>
              ספק למודל מידע רלוונטי לשאלה, כגון חומר, שאלות אחרות לדוגמה וכו'
            </p>
          </div>

          {/* Step 3: Magic (AI question generation) */}
          <div className="step">
            <div className="step-title">
              <div className="step-icon">{/* Optional icon */}</div>
              <h2>קסם!</h2>
            </div>
            <p>המודל ייצור לך שאלה ותשובות חדשות לגמרי!</p>
          </div>
        </div>
      </section>

      {/* 🔔 Snackbar for feedback after saving the key */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </main>
  );
};

export default Home;
